import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
	REPORT_COMPLAINT_CAR_MODEL_FETCH,
	REPORT_COMPLAINT_CATEGORIES_FETCH,
	REPORT_SURVEY_FETCH,
	REPORT_TICKET_FETCH,
	REPORT_TICKET_3MONTHS_FETCH,
	REPORT_TICKET_6MONTHS_FETCH,
	REPORT_TICKET_YTD_FETCH,
	REPORT_TICKET_SHOWROOM_STATUSES_FETCH,
	REPORT_TICKET_SERVICE_STATUSES_FETCH,
	REPORT_TICKETS_SHOWROOM_FETCH,
	REPORT_TICKETS_SERVICE_FETCH,
	REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH,
	REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH,
	REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH,
	REPORT_TICKETS_HOTSHEET_SERVICE_FETCH,
	REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH,
	REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH,
	REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH,
	REPORT_TICKETS_CALLCENTER_SERVICE_FETCH,
	REPORT_TICKET_KPI_FETCH,
	REPORT_TICKET_KPI_3MONTHS_FETCH,
	REPORT_TICKET_KPI_6MONTHS_FETCH,
	REPORT_TICKET_KPI_YTD_FETCH,
	REPORT_TICKET_KPI_SURVEY_FETCH,
	REPORT_CASE_CLOSED_EXPORT_EXCEL,
	REPORT_CASE_CLOSED_V1_EXPORT_EXCEL,
	REPORT_RESPONSE_RATE_SHOWROOM_FETCH,
	REPORT_RESPONSE_RATE_SERVICE_FETCH,
	REPORT_RESPONSE_RATE_EXPORT_EXCEL,
	REPORT_NOTIFY_SHOWROOM_FETCH,
	REPORT_NOTIFY_SERVICE_FETCH,
	REPORT_NOTIFY_EXPORT_EXCEL,
	REPORT_PDCA_EXPORT_EXCEL,
	REPORT_TICKET_KPI_EXPORT_EXCEL,
	REPORT_QVOC_KPI_EXPORT_EXCEL,
	REPORT_QVOC_KPI_FETCH,
	REPORT_TICKET_KPI_ALL_FETCH
} from "../actions/types";
import {
	reportComplaintCarModelFetchSuccess,
	reportComplaintCategoriesFetchSuccess,
	reportSurveyFetchSuccess,
	reportTicketFetchSuccess,
	reportTicket3MonthsFetchSuccess,
	reportTicket6MonthsFetchSuccess,
	reportTicketYtdFetchSuccess,
	reportTicketShowroomStatusFetchSuccess,
	reportTicketServiceStatusFetchSuccess,
	reportTicketsShowroomFetchSuccess,
	reportTicketsServiceFetchSuccess,
	reportTicketsShowroomFormUpdate,
	reportTicketsServiceFormUpdate,
	reportTicketHotSheetShowroomStatusFetchSuccess,
	reportTicketHotSheetServiceStatusFetchSuccess,
	reportTicketsHotSheetShowroomFetchSuccess,
	reportTicketsHotSheetServiceFetchSuccess,
	reportTicketsHotSheetShowroomFormUpdate,
	reportTicketsHotSheetServiceFormUpdate,
	reportTicketCallCenterShowroomStatusFetchSuccess,
	reportTicketCallCenterServiceStatusFetchSuccess,
	reportTicketsCallCenterShowroomFetchSuccess,
	reportTicketsCallCenterServiceFetchSuccess,
	reportTicketsCallCenterShowroomFormUpdate,
	reportTicketsCallCenterServiceFormUpdate,
	reportTicketKpiFetchSuccess,
	reportTicketKpi3MonthsFetchSuccess,
	reportTicketKpi6MonthsFetchSuccess,
	reportResponseRateShowroomFetchSuccess,
	reportResponseRateServiceFetchSuccess,
	reportTicketKpiYtdFetchSuccess,
	reportTicketKpiSurveyFetchSuccess,
	reportNotifyShowroomFetchSuccess,
	reportNotifyServiceFetchSuccess,
	reportQvocKpiFetchSuccess,
	reportTicketKpiAllFetchSuccess
} from "../actions/ReportActions";
import { showErrorMessage, hideLoader } from "../actions/NotifyActions";
import { authorizationHeader, getErrorMessage } from "../util/apiUtil";
import axios from "axios";
import FileSaver from "file-saver";
import moment from "moment";
import _ from "lodash";

// API
export const reportComplaintCarModelFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/car_model`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

export const reportSurveyFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_SURVEY_URL}/api/dashboard/`;
	let params = { ...payload };
	let auth = { username: process.env.REACT_APP_API_SURVEY_USER, password: process.env.REACT_APP_API_SURVEY_PASSWORD };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.post(url, params, { auth })
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

export const reportTicketKpiSurveyFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_SURVEY_URL}/api/dashboard/`;
	let params = { ...payload };
	let auth = { username: process.env.REACT_APP_API_SURVEY_USER, password: process.env.REACT_APP_API_SURVEY_PASSWORD };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.post(url, params, { auth })
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
}

export const reportResponseRateFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_SURVEY_URL}/api/responserate/`;
	let params = { ...payload };
	let auth = { username: process.env.REACT_APP_API_SURVEY_USER, password: process.env.REACT_APP_API_SURVEY_PASSWORD };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.post(url, params, { auth })
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
}

export const reportTicketFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/kpi`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

export const reportQvocKpiFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/kpi/v2`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

export const reportTicketKpiAllFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/dealer/kpi/v2`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

export const reportNotifyFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/notify`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

export const reportTicketKpiFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/dealer/kpi`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

export const reportTicketsFetchRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);
	params.sort = "created_oa_date";
	params.order = "desc";

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params
		})
		.then(response => response.data)
		.catch(error => {
			throw error;
		});
};

export const reportCaseClosedExportExcelRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/excel/caseclosed`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params,
			responseType: "blob"
		})
		.then(response => {
			return response.data;
		})
		.catch(error => {
			throw error;
		});
}

export const reportCaseClosedV1ExportExcelRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/excel/caseclosed/v1`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params,
			responseType: "blob"
		})
		.then(response => {
			return response.data;
		})
		.catch(error => {
			throw error;
		});
}

export const reportResponseRateExportExcelRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/excel/responserate`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params,
			responseType: "blob"
		})
		.then(response => {
			return response.data;
		})
		.catch(error => {
			throw error;
		});
}

export const reportNotifyExportExcelRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/excel/notify`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params,
			responseType: "blob"
		})
		.then(response => {
			return response.data;
		})
		.catch(error => {
			throw error;
		});
}

export const reportPdcaExportExcelRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/excel/pdca`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params,
			responseType: "blob"
		})
		.then(response => {
			return response.data;
		})
		.catch(error => {
			throw error;
		});
}

export const reportQvocKpiExportExcelRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/excel/qvoc/kpi`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params,
			responseType: "blob"
		})
		.then(response => {
			return response.data;
		})
		.catch(error => {
			throw error;
		});
}

export const reportTicketKpiExportExcelRequest = async payload => {
	let url = `${process.env.REACT_APP_API_URL}/api/tickets/report/excel/dealer/kpi`;
	let params = { ...payload };
	params = _.omitBy(params, _.isEmpty);

	return await axios
		.get(url, {
			headers: authorizationHeader("bearer"),
			params: params,
			responseType: "blob"
		})
		.then(response => {
			return response.data;
		})
		.catch(error => {
			throw error;
		});
}

// WORKER
function* reportComplaintCarModelFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		let data = yield call(reportComplaintCarModelFetchRequest, payload);

		data = _.reject(data, ["car_model", ""]);
		/*
		if (data.length > 0) {
			data.unshift({ count: _.sumBy(data, "count"), car_model: "All" });
		}
		*/
		yield put(reportComplaintCarModelFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportComplaintCategoriesFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		let data_ = _.filter(data, "complaint_categories");

		let result = { showroom: {}, service: {}, all: {}, total: { showroom: 0, service: 0 } };
		data_.forEach(value => {
			const { complaint_categories, type } = value;
			let found = { showroom: {}, service: {}, all: {} };
			Object.keys(complaint_categories).map(key => {
				if (complaint_categories[key] && key.indexOf("100") <= 0) {
					let catagory = key.replace(/[0-9]/g, "");
					if (!found[type][catagory]) {
						result["all"][catagory] = result["all"][catagory] ? result["all"][catagory] + 1 : 1;
						found[type][catagory] = true;
					}
					result.total[type] += 1;
					result[type][key] = result[type][key] ? result[type][key] + 1 : 1;
					result["all"][key] = result["all"][key] ? result["all"][key] + 1 : 1;
				}
			});
		});
		result.showroom_ = Object.keys(result.showroom).sort(function (a, b) {
			return result.showroom[b] - result.showroom[a];
		});
		result.service_ = Object.keys(result.service).sort(function (a, b) {
			return result.service[b] - result.service[a];
		});
		const { S, A, F, P, O, ...all } = result.all;
		result.all_ = Object.keys(all).sort(function (a, b) {
			return result.all[b] - result.all[a];
		});

		yield put(reportComplaintCategoriesFetchSuccess(result));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportSurveyFetch({ payload }) {
	try {
		const data = yield call(reportSurveyFetchRequest, payload);
		if (data.success) {
			yield put(reportSurveyFetchSuccess(data.data));
		}
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketFetchRequest, payload);
		yield put(reportTicketFetchSuccess(data));
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicket3MonthsFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketFetchRequest, payload);
		yield put(reportTicket3MonthsFetchSuccess(data));
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicket6MonthsFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketFetchRequest, payload);
		yield put(reportTicket6MonthsFetchSuccess(data));
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketYtdFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketFetchRequest, payload);
		yield put(reportTicketYtdFetchSuccess(data));
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketKpiFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketKpiFetchRequest, payload);
		yield put(reportTicketKpiFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketKpi3MonthsFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketKpiFetchRequest, payload);
		yield put(reportTicketKpi3MonthsFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketKpi6MonthsFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketKpiFetchRequest, payload);
		yield put(reportTicketKpi6MonthsFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketKpiYtdFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketKpiFetchRequest, payload);
		yield put(reportTicketKpiYtdFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketKpiSurveyFetch({ payload }) {
	try {
		const data = yield call(reportTicketKpiSurveyFetchRequest, payload);
		if (data.success) {
			yield put(reportTicketKpiSurveyFetchSuccess(data.data));
		}
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketShowroomStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		let from = new Date(payload.from_created_date);
		let to = new Date(payload.to_created_date);

		let result = {};
		while (to > from) {
			to.setDate(to.getDate() - 1);
			result[moment(to).format("YYYY-MM-DD")] = { W: 0, C: 0, S: 0, T: 0, R: 0, B: 0 };
		}

		data.forEach(value => {
			const { created_date, status } = value;
			result[moment(created_date).format("YYYY-MM-DD")][status] += 1;
		});

		yield put(reportTicketShowroomStatusFetchSuccess(result));
		yield put(reportTicketsShowroomFormUpdate(payload));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketServiceStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		let from = new Date(payload.from_created_date);
		let to = new Date(payload.to_created_date);

		let result = {};
		while (to > from) {
			to.setDate(to.getDate() - 1);
			result[moment(to).format("YYYY-MM-DD")] = { W: 0, C: 0, S: 0, T: 0, R: 0, B: 0 };
		}

		data.forEach(value => {
			const { created_date, status } = value;
			result[moment(created_date).format("YYYY-MM-DD")][status] += 1;
		});

		yield put(reportTicketServiceStatusFetchSuccess(result));
		yield put(reportTicketsServiceFormUpdate(payload));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketsShowroomFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		yield put(reportTicketsShowroomFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketsServiceFetch({ payload }) {

	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;


		const data = yield call(reportTicketsFetchRequest, payload);
		yield put(reportTicketsServiceFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketHotSheetShowroomStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		let from = new Date(payload.from_created_date);
		let to = new Date(payload.to_created_date);

		let result = {};
		while (to > from) {
			to.setDate(to.getDate() - 1);
			result[moment(to).format("YYYY-MM-DD")] = { W: 0, C: 0, S: 0, T: 0, R: 0, B: 0 };
		}

		data.forEach(value => {
			const { created_date, status } = value;
			result[moment(created_date).format("YYYY-MM-DD")][status] += 1;
		});

		yield put(reportTicketHotSheetShowroomStatusFetchSuccess(result));
		yield put(reportTicketsHotSheetShowroomFormUpdate(payload));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketHotSheetServiceStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		let from = new Date(payload.from_created_date);
		let to = new Date(payload.to_created_date);

		let result = {};
		while (to > from) {
			to.setDate(to.getDate() - 1);
			result[moment(to).format("YYYY-MM-DD")] = { W: 0, C: 0, S: 0, T: 0, R: 0, B: 0 };
		}

		data.forEach(value => {
			const { created_date, status } = value;
			result[moment(created_date).format("YYYY-MM-DD")][status] += 1;
		});

		yield put(reportTicketHotSheetServiceStatusFetchSuccess(result));
		yield put(reportTicketsHotSheetServiceFormUpdate(payload));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketsHotSheetShowroomFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		yield put(reportTicketsHotSheetShowroomFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketsHotSheetServiceFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;


		const data = yield call(reportTicketsFetchRequest, payload);
		yield put(reportTicketsHotSheetServiceFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketCallCenterShowroomStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		let from = new Date(payload.from_created_date);
		let to = new Date(payload.to_created_date);

		let result = {};
		while (to > from) {
			to.setDate(to.getDate() - 1);
			result[moment(to).format("YYYY-MM-DD")] = { W: 0, C: 0, S: 0, T: 0, R: 0, B: 0 };
		}

		data.forEach(value => {
			const { created_date, status } = value;
			result[moment(created_date).format("YYYY-MM-DD")][status] += 1;
		});

		yield put(reportTicketCallCenterShowroomStatusFetchSuccess(result));
		yield put(reportTicketsCallCenterShowroomFormUpdate(payload));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketCallCenterServiceStatusFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		let from = new Date(payload.from_created_date);
		let to = new Date(payload.to_created_date);

		let result = {};
		while (to > from) {
			to.setDate(to.getDate() - 1);
			result[moment(to).format("YYYY-MM-DD")] = { W: 0, C: 0, S: 0, T: 0, R: 0, B: 0 };
		}

		data.forEach(value => {
			const { created_date, status } = value;
			result[moment(created_date).format("YYYY-MM-DD")][status] += 1;
		});

		yield put(reportTicketCallCenterServiceStatusFetchSuccess(result));
		yield put(reportTicketsCallCenterServiceFormUpdate(payload));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketsCallCenterShowroomFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportTicketsFetchRequest, payload);
		yield put(reportTicketsCallCenterShowroomFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketsCallCenterServiceFetch({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;


		const data = yield call(reportTicketsFetchRequest, payload);
		yield put(reportTicketsCallCenterServiceFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportCaseClosedExportExcel({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportCaseClosedExportExcelRequest, payload);
		FileSaver.saveAs(data, `tickets_caseclosed_${payload.type == "service" ? "aftersales" : payload.type}_${payload.month + payload.year}.xlsx`);
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportCaseClosedV1ExportExcel({ payload }) {
	try {
		payload.from_created_date =
			payload.from_created_date instanceof Object
				? payload.from_created_date.format("YYYY-MM-DD")
				: payload.from_created_date;
		payload.to_created_date =
			payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportCaseClosedV1ExportExcelRequest, payload);
		FileSaver.saveAs(data, `tickets_caseclosed_${payload.type == "service" ? "aftersales" : payload.type}_${payload.month + payload.year}.xlsx`);
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportResponseRateExportExcel({ payload }) {
	try {
		payload.from = payload.from instanceof Object ? payload.from.format("YYYY-MM-DD") : payload.from;
		payload.to = payload.to instanceof Object ? payload.to.format("YYYY-MM-DD") : payload.to;

		const data = yield call(reportResponseRateExportExcelRequest, payload);
		FileSaver.saveAs(data, `responserate_${payload.type == "service" ? "aftersales" : payload.type}_${payload.from + '_to_' + payload.to}.xlsx`);
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportResponseRateShowroomFetch({ payload }) {
	try {
		payload.from = payload.from instanceof Object ? payload.from.format("YYYY-MM-DD") : payload.from;
		payload.to = payload.to instanceof Object ? payload.to.format("YYYY-MM-DD") : payload.to;

		const data = yield call(reportResponseRateFetchRequest, payload);
		if (data.success) {
			yield put(reportResponseRateShowroomFetchSuccess(data.data));
		}
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportResponseRateServiceFetch({ payload }) {
	try {
		payload.from = payload.from instanceof Object ? payload.from.format("YYYY-MM-DD") : payload.from;
		payload.to = payload.to instanceof Object ? payload.to.format("YYYY-MM-DD") : payload.to;

		const data = yield call(reportResponseRateFetchRequest, payload);
		if (data.success) {
			yield put(reportResponseRateServiceFetchSuccess(data.data));
		}
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportNotifyShowroomFetch({ payload }) {
	try {
		payload.from_notified_date = payload.from_notified_date instanceof Object ? payload.from_notified_date.format("YYYY-MM-DD") : payload.from_notified_date;
		payload.to_notified_date = payload.to_notified_date instanceof Object ? payload.to_notified_date.format("YYYY-MM-DD") : payload.to_notified_date;

		const data = yield call(reportNotifyFetchRequest, payload);
		yield put(reportNotifyShowroomFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportNotifyServiceFetch({ payload }) {
	try {
		payload.from_notified_date = payload.from_notified_date instanceof Object ? payload.from_notified_date.format("YYYY-MM-DD") : payload.from_notified_date;
		payload.to_notified_date = payload.to_notified_date instanceof Object ? payload.to_notified_date.format("YYYY-MM-DD") : payload.to_notified_date;

		const data = yield call(reportNotifyFetchRequest, payload);
		yield put(reportNotifyServiceFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportNotifyExportExcel({ payload }) {
	try {
		payload.from_notified_date = payload.from_notified_date instanceof Object ? payload.from_notified_date.format("YYYY-MM-DD") : payload.from_notified_date;
		payload.to_notified_date = payload.to_notified_date instanceof Object ? payload.to_notified_date.format("YYYY-MM-DD") : payload.to_notified_date;

		const data = yield call(reportNotifyExportExcelRequest, payload);
		FileSaver.saveAs(data, `notify_${payload.ticket.type == "service" ? "aftersales" : payload.ticket.type}_${payload.channel}_${moment(payload.from_notified_date).format('YYYYMM')}.xlsx`);
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportPdcaExportExcel({ payload }) {
	try {
		payload.from_created_date = payload.from_created_date instanceof Object ? payload.from_created_date.format("YYYY-MM-DD") : payload.from_created_date;
		payload.to_created_date = payload.to_created_date instanceof Object ? payload.to_created_date.format("YYYY-MM-DD") : payload.to_created_date;

		const data = yield call(reportPdcaExportExcelRequest, payload);
		FileSaver.saveAs(data, `PDCA_${payload.type == "service" ? "Service" : "Sales"}_${moment().format("DDMMYY")}.xlsx`);
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}


function*  reportTicketKpiExportExcel({ payload }) {
	try {
		const data = yield call(reportTicketKpiExportExcelRequest, payload);
		FileSaver.saveAs(data, `TICKET_KPI_${moment().format("DDMMYY")}.xlsx`);
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function*  reportQvocKpiExportExcel({ payload }) {
	try {
		const data = yield call(reportQvocKpiExportExcelRequest, payload);
		FileSaver.saveAs(data, `QVOC_KPI_${moment().format("DDMMYY")}.xlsx`);
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportQvocKpiFetch({ payload }) {
	try {
		const data = yield call(reportQvocKpiFetchRequest, payload);
		yield put(reportQvocKpiFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}

function* reportTicketKpiAllFetch({ payload }) {
	try {
		const data = yield call(reportTicketKpiAllFetchRequest, payload);
		yield put(reportTicketKpiAllFetchSuccess(data));
		yield put(hideLoader());
	} catch (error) {
		yield put(showErrorMessage(getErrorMessage(error)));
	}
}


// WATCHER
function* reportComplaintCarModelFetchWatcher() {
	yield takeEvery(REPORT_COMPLAINT_CAR_MODEL_FETCH, reportComplaintCarModelFetch);
}

function* reportComplaintCategoriesFetchWatcher() {
	yield takeEvery(REPORT_COMPLAINT_CATEGORIES_FETCH, reportComplaintCategoriesFetch);
}

function* reportSurveyFetchWatcher() {
	yield takeEvery(REPORT_SURVEY_FETCH, reportSurveyFetch);
}

function* reportTicketFetchWatcher() {
	yield takeEvery(REPORT_TICKET_FETCH, reportTicketFetch);
}

function* reportTicket3MonthsFetchWatcher() {
	yield takeEvery(REPORT_TICKET_3MONTHS_FETCH, reportTicket3MonthsFetch);
}
function* reportTicket6MonthsFetchWatcher() {
	yield takeEvery(REPORT_TICKET_6MONTHS_FETCH, reportTicket6MonthsFetch);
}

function* reportTicketYtdFetchWatcher() {
	yield takeEvery(REPORT_TICKET_YTD_FETCH, reportTicketYtdFetch);
}

function* reportTicketShowroomStatusFetchWatcher() {
	yield takeEvery(REPORT_TICKET_SHOWROOM_STATUSES_FETCH, reportTicketShowroomStatusFetch);
}

function* reportTicketServiceStatusFetchWatcher() {
	yield takeEvery(REPORT_TICKET_SERVICE_STATUSES_FETCH, reportTicketServiceStatusFetch);
}

function* reportTicketsShowroomFetchWatcher() {
	yield takeEvery(REPORT_TICKETS_SHOWROOM_FETCH, reportTicketsShowroomFetch);
}

function* reportTicketsServiceFetchWatcher() {
	yield takeEvery(REPORT_TICKETS_SERVICE_FETCH, reportTicketsServiceFetch);
}


function* reportTicketHotSheetShowroomStatusFetchWatcher() {
	yield takeEvery(REPORT_TICKET_HOTSHEET_SHOWROOM_STATUSES_FETCH, reportTicketHotSheetShowroomStatusFetch);
}

function* reportTicketHotSheetServiceStatusFetchWatcher() {
	yield takeEvery(REPORT_TICKET_HOTSHEET_SERVICE_STATUSES_FETCH, reportTicketHotSheetServiceStatusFetch);
}

function* reportTicketsHotSheetShowroomFetchWatcher() {
	yield takeEvery(REPORT_TICKETS_HOTSHEET_SHOWROOM_FETCH, reportTicketsHotSheetShowroomFetch);
}

function* reportTicketsHotSheetServiceFetchWatcher() {
	yield takeEvery(REPORT_TICKETS_HOTSHEET_SERVICE_FETCH, reportTicketsHotSheetServiceFetch);
}

function* reportTicketCallCenterShowroomStatusFetchWatcher() {
	yield takeEvery(REPORT_TICKET_CALLCENTER_SHOWROOM_STATUSES_FETCH, reportTicketCallCenterShowroomStatusFetch);
}

function* reportTicketCallCenterServiceStatusFetchWatcher() {
	yield takeEvery(REPORT_TICKET_CALLCENTER_SERVICE_STATUSES_FETCH, reportTicketCallCenterServiceStatusFetch);
}

function* reportTicketsCallCenterShowroomFetchWatcher() {
	yield takeEvery(REPORT_TICKETS_CALLCENTER_SHOWROOM_FETCH, reportTicketsCallCenterShowroomFetch);
}

function* reportTicketsCallCenterServiceFetchWatcher() {
	yield takeEvery(REPORT_TICKETS_CALLCENTER_SERVICE_FETCH, reportTicketsCallCenterServiceFetch);
}

function* reportTicketKpiFetchWatcher() {
	yield takeEvery(REPORT_TICKET_KPI_FETCH, reportTicketKpiFetch);
}

function* reportTicketKpi3MonthsFetchWatcher() {
	yield takeEvery(REPORT_TICKET_KPI_3MONTHS_FETCH, reportTicketKpi3MonthsFetch);
}

function* reportTicketKpi6MonthsFetchWatcher() {
	yield takeEvery(REPORT_TICKET_KPI_6MONTHS_FETCH, reportTicketKpi6MonthsFetch);
}

function* reportTicketKpiYtdFetchWatcher() {
	yield takeEvery(REPORT_TICKET_KPI_YTD_FETCH, reportTicketKpiYtdFetch);
}

function* reportTicketKpiSurveyFetchWatcher() {
	yield takeEvery(REPORT_TICKET_KPI_SURVEY_FETCH, reportTicketKpiSurveyFetch);
}

function* reportCaseClosedExportExcelWatcher() {
	yield takeEvery(REPORT_CASE_CLOSED_EXPORT_EXCEL, reportCaseClosedExportExcel);
}

function* reportCaseClosedV1ExportExcelWatcher() {
	yield takeEvery(REPORT_CASE_CLOSED_V1_EXPORT_EXCEL, reportCaseClosedV1ExportExcel);
}

function* reportResponseRateShowroomFetchWatcher() {
	yield takeEvery(REPORT_RESPONSE_RATE_SHOWROOM_FETCH, reportResponseRateShowroomFetch);
}

function* reportResponseRateServiceFetchWatcher() {
	yield takeEvery(REPORT_RESPONSE_RATE_SERVICE_FETCH, reportResponseRateServiceFetch);
}

function* reportResponseRateExportExcelWatcher() {
	yield takeEvery(REPORT_RESPONSE_RATE_EXPORT_EXCEL, reportResponseRateExportExcel);
}

function* reportNotifyShowroomFetchWatcher() {
	yield takeEvery(REPORT_NOTIFY_SHOWROOM_FETCH, reportNotifyShowroomFetch);
}

function* reportNotifyServiceFetchWatcher() {
	yield takeEvery(REPORT_NOTIFY_SERVICE_FETCH, reportNotifyServiceFetch);
}

function* reportNotifyExportExcelWatcher() {
	yield takeEvery(REPORT_NOTIFY_EXPORT_EXCEL, reportNotifyExportExcel);
}

function* reportPdcaExportExcelWatcher() {
	yield takeEvery(REPORT_PDCA_EXPORT_EXCEL, reportPdcaExportExcel);
}

function* reportTicketKpiExportExcelWatcher() {
	yield takeEvery(REPORT_TICKET_KPI_EXPORT_EXCEL, reportTicketKpiExportExcel);
}

function* reportQvocKpiExportExcelWatcher() {
	yield takeEvery(REPORT_QVOC_KPI_EXPORT_EXCEL, reportQvocKpiExportExcel);
}

function* reportQvocKpiFetchWatcher() {
	yield takeEvery(REPORT_QVOC_KPI_FETCH, reportQvocKpiFetch);
}

function* reportTicketKpiAllFetchWatcher() {
	yield takeEvery(REPORT_TICKET_KPI_ALL_FETCH, reportTicketKpiAllFetch);
}

export default function* rootSaga() {
	yield all([
		fork(reportComplaintCarModelFetchWatcher),
		fork(reportComplaintCategoriesFetchWatcher),
		fork(reportSurveyFetchWatcher),
		fork(reportTicketFetchWatcher),
		fork(reportTicket3MonthsFetchWatcher),
		fork(reportTicket6MonthsFetchWatcher),
		fork(reportTicketYtdFetchWatcher),
		fork(reportTicketShowroomStatusFetchWatcher),
		fork(reportTicketServiceStatusFetchWatcher),
		fork(reportTicketsShowroomFetchWatcher),
		fork(reportTicketsServiceFetchWatcher),
		fork(reportTicketHotSheetShowroomStatusFetchWatcher),
		fork(reportTicketHotSheetServiceStatusFetchWatcher),
		fork(reportTicketsHotSheetShowroomFetchWatcher),
		fork(reportTicketsHotSheetServiceFetchWatcher),
		fork(reportTicketCallCenterShowroomStatusFetchWatcher),
		fork(reportTicketCallCenterServiceStatusFetchWatcher),
		fork(reportTicketsCallCenterShowroomFetchWatcher),
		fork(reportTicketsCallCenterServiceFetchWatcher),
		fork(reportTicketKpiFetchWatcher),
		fork(reportTicketKpi3MonthsFetchWatcher),
		fork(reportTicketKpi6MonthsFetchWatcher),
		fork(reportTicketKpiYtdFetchWatcher),
		fork(reportTicketKpiSurveyFetchWatcher),
		fork(reportCaseClosedExportExcelWatcher),
		fork(reportCaseClosedV1ExportExcelWatcher),
		fork(reportResponseRateShowroomFetchWatcher),
		fork(reportResponseRateServiceFetchWatcher),
		fork(reportResponseRateExportExcelWatcher),
		fork(reportNotifyShowroomFetchWatcher),
		fork(reportNotifyServiceFetchWatcher),
		fork(reportNotifyExportExcelWatcher),
		fork(reportPdcaExportExcelWatcher),
		fork(reportTicketKpiExportExcelWatcher),
		fork(reportQvocKpiExportExcelWatcher),
		fork(reportQvocKpiFetchWatcher),
		fork(reportTicketKpiAllFetchWatcher),
	]);
}
